<template>
  <div class="projectcover-div" >
    <!-- :style="{ 'background-image': 'url(' + projects[index].projectCover.projectCoverBackgroundImage + ')' }"-->
    <menu-side></menu-side>
    <div class="banner">
      <img v-if="!this.isMobile" class="bg" :src="projects[index].projectCover.projectCoverBackgroundImage"
           :srcset="projects[index].projectCover.projectCoverBackgroundImage" alt="Hippotec">
      <img v-else class="bg" :src="projects[index].projectCover.projectCoverUpBanner"
           :srcset="projects[index].projectCover.projectCoverUpBanner" alt="Hippotec">
      <img class="banner-logo" :src="projects[index].projectCover.projectCoverBackgroundImageLogo" alt="Hippotec">
      <div class="overlay"></div>

      <!--      <img class="banner-logo" :src="projects[index].logo" :srcset="projects[index].logo" alt="Hippotec">-->
      <img class="menu-project-move-left" v-if="!this.isMobile" @click="showAppDetailsNew(parseInt(index) - 1)" src="/static/img/global/upper-menu-left.svg"
           alt="left">
      <img class="menu-project-move-right" v-if="!this.isMobile" @click="showAppDetailsNew(parseInt(index) + 1)" src="/static/img/global/upper-menu-right.svg"
           alt="left">
    </div>

    <div class="projectdescription-div">
      <div class="projectcover-textdiv">
        <div class="title">{{ projects[index].descriptionComponent.descriptionTitle }}</div>
        <!--        <h2 class="projectcover-subtitle">{{ projects[index].descriptionComponent.descriptionSubTitle }}</h2>-->
        <div class="projectcover-text">{{ projects[index].descriptionComponent.descriptionText }}</div>
        <h1 class="projectcover-platformstext">{{ projects[index].descriptionComponent.platforms }}</h1>
      </div>
    </div>
    <div v-if="projects[index].uxUiDesignWide.middleBanner" class="banner-middle">
      <div class="banner-bottom-back" :style="{background: projects[index].uxUiDesignWide.middleBanner.backgroundColor}">
        <div class="projectcover-textdiv">
          <div class="title" :style="{color: projects[index].uxUiDesignWide.middleBanner.titleColor}">
            {{projects[index].uxUiDesignWide.middleBanner.titleText}}
          </div>
          <div class="text" :style="{color: projects[index].uxUiDesignWide.middleBanner.textColor}">
            {{projects[index].uxUiDesignWide.middleBanner.text}}
          </div>
          <div class="images">
            <img class="single-image" v-if="!this.isMobile" :src=projects[index].uxUiDesignWide.middleBanner.imageWeb alt="">
            <img v-else :src=projects[index].uxUiDesignWide.middleBanner.imageMobile alt="">
          </div>
        </div>
      </div>


    </div>
    <div class="banner-bottom">
      <div class="banner-bottom-back" :style="{background: projects[index].uxUiDesignWide.backgroundColor}">
        <div class="projectcover-textdiv">
          <div class="title" :style="{color: projects[index].uxUiDesignWide.titleColor}">
            {{projects[index].uxUiDesignWide.title}}
          </div>
          <div class="text" :style="{color: projects[index].uxUiDesignWide.titleTextColor}">
            {{projects[index].uxUiDesignWide.text}}
          </div>
          <div class="images">
            <carousel paginationPosition='top' :paginationEnabled=false :navigate-to="carouselPageNumber" @pageChange="pageChange"
                      :scrollPerPage="true" :perPage="1" :paginationPadding="10" :loop="false" :autoplayTimeout="15000">

              <slide class="slide" v-for="(slide, index2) in (!this.isMobile? projects[index].uxUiDesignWide.bannerImages : projects[index].uxUiDesignWide.bannerMobileImages)">
                <div class="slide-image">
                  <img :src=slide.image>
                </div>
              </slide>
            </carousel>
          </div>

          <div class="paging-content">
            <div v-for="(item, index2) in (!this.isMobile? projects[index].uxUiDesignWide.bannerImages : projects[index].uxUiDesignWide.bannerMobileImages)">
              <div class="carousel-page-count" @click="navigateToSlide(index2 , index)">
                <img v-if="item.isActive" class="image" :src=projects[index].uiDesign.image>
                <img v-else class="image" style="opacity: 0" src="/static/img/path.png">
                <div v-if="item.isActive" :style="{color: projects[index].uiDesign.colorNew}" class="page">{{ index2 + 1
                  }}
                </div>
                <div v-else class="page">{{ index2 + 1 }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>


    </div>
    <div class="bottom-menu">
      <img class="left" @click="showAppDetailsNew(parseInt(index) - 1)" src="/static/img/global/footer-menu-left.svg" alt="left">
      <img class="middle" @click="seeOurProjects" src="/static/img/global/menu-projects-big.svg" alt="left">
      <img class="right" @click="showAppDetailsNew(parseInt(index) + 1)" src="/static/img/global/footer-menu-right.svg" alt="left">
    </div>
  </div>
</template>
<script>
  //import MenuSide from '../../components/MenuSide'
  import {Carousel, Slide} from 'vue-carousel';

  import MenuSide from '@bit/hippotec.website2019.menu-side';

  export default {
    name: 'ProjectCover',
    components: {
      MenuSide: MenuSide,
      Carousel,
      Slide,
    },
    data() {
      return {
        carouselPageNumber: 0,
        projects: window.projectsData,
        index: this.$route.params.id,
        screenSize: 1,
        window
      }
    },
    methods: {
      pageChange: function(a) {
        this.navigateToSlide(a, this.index)
      },
      navigateToSlide: function (page, projectIndex) {
        //console.log(page, projectIndex)
        let slides;
        if (!this.isMobile)
          slides = this.projects[projectIndex].uxUiDesignWide.bannerImages
        else
          slides = this.projects[projectIndex].uxUiDesignWide.bannerMobileImages
        this.carouselPageNumber = page;
        for (let i = 0; i < slides.length; i++) {
          if (i == page) {
            slides[i].isActive = true
          } else {
            slides[i].isActive = false
          }
        }
      },
      changeProject: function (indexNew) {
        this.index = indexNew
      },
      seeOurProjects: function () {
        this.$router.push('/projects');
      },
      showAppDetails: function () {
        this.$router.push('/details/' + this.index);
      },
      showAppDetailsNew: function (projectIndex) {
        if (projectIndex == -1){
          projectIndex = projectsData.length - 1;
        }else if (projectIndex == projectsData.length){
          projectIndex = 0;
        }
        let newRoute = '/cover/' + projectIndex;
        this.$router.push(newRoute);
        location.reload()
        //this.$router.push('/details/' + projectIndex);
      },
      prepareMobile(isMobile) {
        //console.log(isMobile);
        this.isMobile = isMobile;
        if (isMobile) {
          /*this.mobileSite.titleCenter = 'center';
          this.screenWidth = (window.innerWidth > 0) ? window.innerWidth : screen.width;
          console.log("this.screenWidth: " + this.screenWidth)*/
        }
      }
    },
    created() {
      //this.screenSize = window.innerWidth > 600
      this.prepareMobile(localStorage.isMobile == 'true');
    },
    mounted() {
      window.onpopstate = function() {
        location.reload()
      };
      if (!this.screenSize) {
        document.getElementById('projectcover-div' + this.index).scrollIntoView();
      }
    },
    beforeDestroy () {
      document.removeEventListener("backbutton", this.onBackPressed);
    }
  }
</script>
<style lang="scss" scoped>
  @import "../../assets/scss/projectCover.scss";
</style>



// WEBPACK FOOTER //
// src/pages/ProjectsCovers/ProjectCover.vue